import { useState } from "react";
import { MatchSettingsDrawer } from "../components/sidebar/MatchSettingsDrawer";

interface MatchSettingsPageProps {
  onBack?: () => void;
}

export function MatchSettingsPage({ onBack }: MatchSettingsPageProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const handleClose = () => {
    setIsDrawerOpen(false);
    setTimeout(() => {
      onBack?.();
    }, 300);
  };

  return (
    <div className="h-screen w-full bg-background overflow-hidden flex flex-col">
      <MatchSettingsDrawer
        isOpen={isDrawerOpen}
        onClose={handleClose}
      />
    </div>
  );
}

export default MatchSettingsPage;
